import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import GeneralDatepickersDatepickerWithSidebar from 'lumen/components/general/datepickers/datepicker-with-sidebar';
import HotelBenchmarkInsightDatePickersDatePickerReferencePeriod from 'lumen/components/hotel/benchmark-insight/date-pickers/date-picker-reference-period';
import {
  BENI_REFERENCE_PERIOD_LONG_TRANSLATIONS,
  BENI_REFERENCE_PERIODS,
} from 'lumen/utils/constants/benchmark-insight/beni-constant-values';

// @ts-expect-error: Incorrect type
export default class HotelBenchmarkInsightDropdownsDropdownReferencePeriod extends GeneralDatepickersDatepickerWithSidebar {
  @service('benchmark-insight/beni-service')
  declare benchmarkInsightBeniService: Services['benchmark-insight/beni-service'];
  @service declare intl: Services['intl'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get range() {
    const selectedReferencePeriodOption =
      // @ts-expect-error: Incorrect type
      this.referencePeriodOptions[0].options.find(
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        (option) => option.id === this.args.referencePeriod,
      );

    // @ts-expect-error: Incorrect type
    return selectedReferencePeriodOption.range;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get referencePeriodOptions() {
    return [
      {
        id: 'references',
        title: this.intl.t('datepicker.options.vs_reference'),
        options: [
          {
            text: BENI_REFERENCE_PERIOD_LONG_TRANSLATIONS[
              BENI_REFERENCE_PERIODS.STLY
            ],
            id: BENI_REFERENCE_PERIODS.STLY,
            range: this.benchmarkInsightBeniService.getReferencePeriodDateRange(
              BENI_REFERENCE_PERIODS.STLY,
              // @ts-expect-error: Incorrect type
              // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
              this.args.selectedDateRange,
            ),
          },
          {
            text: BENI_REFERENCE_PERIOD_LONG_TRANSLATIONS[
              BENI_REFERENCE_PERIODS.SDLY
            ],
            id: BENI_REFERENCE_PERIODS.SDLY,
            range: this.benchmarkInsightBeniService.getReferencePeriodDateRange(
              BENI_REFERENCE_PERIODS.SDLY,
              // @ts-expect-error: Incorrect type
              // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
              this.args.selectedDateRange,
            ),
          },
        ],
      },
    ];
  }

  @action
  // @ts-expect-error: Incorrect type
  onChangeReferencePeriod(referencePeriod): void {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    this.args.onChangeReferencePeriod(referencePeriod.id);
  }

  <template>
    {{! @glint-expect-error: Incorrect type }}
    <HotelBenchmarkInsightDatePickersDatePickerReferencePeriod
      @onChangeReferencePeriod={{@onChangeReferencePeriod}}
      @range={{this.range}}
      @referencePeriod={{@referencePeriod}}
      @selectedDateRange={{@selectedDateRange}}
      @sidebarLists={{this.referencePeriodOptions}}
    />
  </template>
}
